import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../context/LanguageContext';
import styles from './PolicyPage.module.css';
import Navbar from '../components/Navbar';

const PrivacyPolicy = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.page}>
      {/* Navbar */}
      <Navbar className={styles.navbar} innerClassName={styles.navInner} brandClassName={styles.navBrand} brand="ReplyShoot">
          <div className={styles.navLinks}>
            <Link to="/" className={styles.navLink}>{t('home', 'Home')}</Link>
            <Link to="/tools" className={styles.navLink}>{t('tools', 'Tools')}</Link>
            <LanguageToggle />
            <Link to="/onboarding" className={styles.navBtn}>{t('getStarted', 'Get Started')}</Link>
          </div>
      </Navbar>

    {/* Hero */}
    <header className={styles.hero}>
      <h1 className={styles.heroTitle}>{t('privacyPolicy', 'Privacy Policy')}</h1>
      <p className={styles.heroSub}>
        {t('privacySub', 'How ReplyShoot collects, uses, discloses, and safeguards your information.')}
      </p>
    </header>

    {/* Content */}
    <main className={styles.content}>
      <article>
        <p>{t('privacyP1', 'This Privacy Policy explains how ReplyShoot collects, uses, discloses, and safeguards information when you use our review management and AI response services. It applies to users of our website, audit tools, onboarding flows, and related support services.')}</p>

        <h2>{t('infoWeCollectTitle', 'Information We Collect')}</h2>
        <p>{t('infoWeCollectSub', 'We collect information needed to provide our services effectively and securely.')}</p>
        <ul>
          <li><strong>{t('contactDetailsTitle', 'Contact and account details:')}</strong> {t('contactDetailsDesc', 'name, email address, business name, phone number, and other information you submit during signup or onboarding.')}</li>
          <li><strong>{t('reviewDataTitle', 'Review and reputation data:')}</strong> {t('reviewDataDesc', 'review text, ratings, timestamps, platform identifiers, and any business details needed to generate accurate audit and response recommendations.')}</li>
          <li><strong>{t('usageInfoTitle', 'Usage information:')}</strong> {t('usageInfoDesc', 'browser and device data, page views, session activity, and analytics information collected through cookies and server logs.')}</li>
        </ul>

        <h2>{t('howWeUseTitle', 'How We Use Your Information')}</h2>
        <p>{t('howWeUseSub', 'We use your data to deliver products and improve overall experience.')}</p>
        <ul>
          <li>{t('howWeUse1', 'Provide review auditing, AI response drafting, onboarding, and subscription management.')}</li>
          <li>{t('howWeUse2', 'Personalize our recommendations and tailor responses to your brand voice.')}</li>
          <li>{t('howWeUse3', 'Send service notifications, billing information, and support communications.')}</li>
          <li>{t('howWeUse4', 'Analyze product usage, improve performance, and develop new features.')}</li>
        </ul>

        <h2>{t('infoSharingTitle', 'Information Sharing')}</h2>
        <p>{t('infoSharingSub', 'We share information only as required to operate the service and when legally necessary.')}</p>
        <ul>
          <li><strong>{t('serviceProvidersTitle', 'Service providers:')}</strong> {t('serviceProvidersDesc', 'trusted partners that support hosting, analytics, payment processing, and email delivery.')}</li>
          <li><strong>{t('legalRequestsTitle', 'Legal requests:')}</strong> {t('legalRequestsDesc', 'when required by law or to protect ReplyShoot, our customers, or others.')}</li>
          <li><strong>{t('businessTransfersTitle', 'Business transfers:')}</strong> {t('businessTransfersDesc', 'in connection with mergers, acquisitions, or asset sales.')}</li>
        </ul>

        <h2>{t('securityRetentionTitle', 'Security and Retention')}</h2>
        <p>{t('securityRetentionDesc', 'We maintain reasonable safeguards designed to protect your data. We retain information only as long as necessary to provide services, comply with legal obligations, and resolve disputes.')}</p>

        <h2>{t('yourRightsTitle', 'Your Rights')}</h2>
        <p>{t('yourRightsDesc', 'You may have rights to access, correct, delete, or object to certain uses of your personal information under applicable law. Contact us if you wish to exercise these rights.')}</p>

        <h2>{t('cookiesTrackingTitle', 'Cookies and Tracking')}</h2>
        <p>{t('cookiesTrackingDesc', 'Cookies and similar technologies help us operate the website, remember preferences, and collect analytics data for continuous improvement.')}</p>

        <h2>{t('policyUpdatesTitle', 'Updates')}</h2>
        <p>{t('policyUpdatesDesc', 'We may update this policy periodically. Any material changes will be posted on our website, and continued use of the service constitutes acceptance of the updated policy.')}</p>
      </article>
    </main>

    {/* Footer */}
    <Footer />
  </div>
  );
};

export default PrivacyPolicy;
